const state = {
  RouterList: [],
  rou: '',
  // 我的项目 上传
  fileList: [], // 存储上传数据
  sourceLeft: '',
  sourceRight: '',
  // 我的项目 上传
  myCompanyCode: '', // 当前公司编码
  newForm: {
    name: '',
    sourceRight: '中文',
    sourceLeft: '英文',
    sourceLang: 'chn', // 源语言编码
    targetLang: 'eng', // 目标语言编码
    domainCode: '', // 领域编码
    domainName: '', // 领域名称
    langDesc: '', //语言对
    sentFileUrlList: [],
  }, // 新建记忆库或术语库
  // filePathList:{},  // 新建项目上传返回的数据
  iff: true,
  myTemplate: '', // 翻译记忆 上传模板
  updateUser: '',
  personageSucceed: false, //用于用户中心修改判断成功状态
  myRow: '',
  MemoryBankList: [], // 项目设置记忆库数组
  ybPopover: false,
  isNovice: false, //是否是新手
  numOfGuide: 0, //显示哪个新手引导
  taskNums:{},//我的任务数量
}
export default state
